import React from 'react';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';

const fa5icons = [
  {
    type: 'category',
    label: 'Writing',
    icons: [
      'pen',
      'bookmark',
      'paragraph',
      'file-alt',
      'keyboard',
      'envelope-open',
      'folder-open',
      'pen-alt',
      'quote-left',
      'paperclip',
      'edit',
      'archive',
      'file',
      'paper-plane',
      'quote-right',
      'book',
      'thumbtack',
      'eraser',
      'pencil-alt',
      'folder',
      'pencil',
      'envelope',
      'sticky-note',
      'newspaper',
      'pencil-alt',
    ],
  },
  {
    type: 'category',
    label: 'Vehicles',
    icons: [
      'space-shuttle',
      'bus',
      'taxi',
      'accessible-icon',
      'shopping-cart',
      'paper-plane',
      'train',
      'ship',
      'ambulance',
      'rocket',
      'fighter-jet',
      'plane',
      'subway',
      'truck',
      'motorcycle',
      'plane-alt',
      'car',
      'wheelchair',
      'bicycle',
    ],
  },
  {
    type: 'category',
    label: 'Users & People',
    icons: [
      'portrait',
      'user-secret',
      'users',
      'male',
      'user-times',
      'user-md',
      'poo',
      'address-book',
      'accessible-icon',
      'power-off',
      'user',
      'id-badge',
      'bed',
      'address-card',
      'user-circle',
      'smile',
      'female',
      'user-plus',
      'meh',
      'id-card',
      'child',
      'user-alt',
      'blind',
      'street-view',
      'frown',
      'wheelchair',
    ],
  },
  {
    type: 'category',
    label: 'Status',
    icons: [
      'question',
      'badge',
      'bell-slash',
      'battery-bolt',
      'thermometer-three-quarters',
      'battery-half',
      'info-circle',
      'eye-slash',
      'exclamation-circle',
      'battery-empty',
      'minus',
      'sign-in-alt',
      'calendar-times',
      'sign-out',
      'unlock',
      'minus-circle',
      'file-alt',
      'toggle-off',
      'file-edit',
      'calendar-edit',
      'file-plus',
      'info-square',
      'battery-full',
      'ban',
      'minus-octagon',
      'thermometer-half',
      'cart-arrow-down',
      'folder-open',
      'eye',
      'unlock-alt',
      'battery-slash',
      'shield',
      'lock-open',
      'thermometer-quarter',
      'shopping-cart',
      'calendar',
      'minus-hexagon',
      'battery-quarter',
      'file-check',
      'file',
      'lock-alt',
      'exclamation',
      'calendar-plus',
      'sign-in',
      'calendar-minus',
      'plus-hexagon',
      'cart-plus',
      'toggle-on',
      'battery-three-quarters',
      'shield-alt',
      'file-exclamation',
      'calendar-alt',
      'badge-check',
      'thermometer-full',
      'folder',
      'plus-square',
      'thumbs-up',
      'minus-square',
      'plus-circle',
      'question-square',
      'calendar-check',
      'shield-check',
      'lock-open-alt',
      'thermometer-empty',
      'file-times',
      'calendar-exclamation',
      'plus-octagon',
      'bell',
      'exclamation-square',
      'info',
      'sign-out-alt',
      'file-minus',
      'lock',
      'question-circle',
      'thumbs-down',
      'plus',
      'exclamation-triangle',
    ],
  },
  {
    type: 'category',
    label: 'Spinners',
    icons: [
      'badge',
      'life-ring',
      'snowflake',
      'certificate',
      'cog',
      'crosshairs',
      'sun',
      'circle-notch',
      'spinner',
      'compass',
      'sync',
      'spinner-third',
      'asterisk',
    ],
  },
  {
    type: 'category',
    label: 'Shapes',
    icons: [
      'circle',
      'badge',
      'bookmark',
      'comment',
      'rectangle-landscape',
      'map-marker',
      'spade',
      'cloud',
      'diamond',
      'certificate',
      'ticket',
      'shield',
      'star',
      'triangle',
      'calendar',
      'octagon',
      'file',
      'heart',
      'rectangle-wide',
      'hexagon',
      'folder',
      'rectangle-portrait',
      'square',
      'play',
      'club',
    ],
  },
  {
    type: 'category',
    label: 'Payments & Shopping',
    icons: [
      'badge',
      'bookmark',
      'credit-card-front',
      'trophy-alt',
      'stripe',
      'cc-stripe',
      'camera',
      'cc-amex',
      'key',
      'cc-visa',
      'certificate',
      'cart-arrow-down',
      'cc-paypal',
      'gift',
      'bullhorn',
      'star',
      'shopping-cart',
      'stripe-s',
      'handshake',
      'gem',
      'cc-discover',
      'heart',
      'cart-plus',
      'cc-mastercard',
      'google-wallet',
      'tag',
      'cc-jcb',
      'apple-pay',
      'paypal',
      'trophy',
      'thumbs-up',
      'amazon-pay',
      'camera-alt',
      'cc-diners-club',
      'credit-card',
      'bell',
      'cc-apple-pay',
      'shopping-bag',
      'camera-retro',
      'shopping-basket',
      'thumbs-down',
      'star-exclamation',
      'cc-amazon-pay',
      'credit-card-blank',
      'tags',
      'ethereum',
    ],
  },
  {
    type: 'category',
    label: 'Objects',
    icons: [
      'tablet-alt',
      'money-bill-alt',
      'pen',
      'space-shuttle',
      'ticket-alt',
      'bookmark',
      'tachometer-alt',
      'trophy-alt',
      'tree-alt',
      'university',
      'bus',
      'cut',
      'building',
      'shower',
      'map-marker',
      'magic',
      'phone',
      'lightbulb',
      'mobile-android',
      'taxi',
      'tablet-android-alt',
      'unlock',
      'camera',
      'image',
      'jack-o-lantern',
      'file-alt',
      'cloud',
      'keyboard',
      'envelope-open',
      'stopwatch',
      'key',
      'life-ring',
      'gavel',
      'magnet',
      'snowflake',
      'fax',
      'utensil-fork',
      'medkit',
      'mobile-android-alt',
      'clipboard',
      'bug',
      'cogs',
      'cog',
      'eye',
      'beer',
      'trash',
      'pen-alt',
      'unlock-alt',
      'tablet-android',
      'film',
      'ticket',
      'umbrella',
      'gift',
      'bullhorn',
      'futbol',
      'map-pin',
      'paperclip',
      'flag-checkered',
      'sun',
      'bomb',
      'shield',
      'fire',
      'lock-open',
      'star',
      'hourglass',
      'trash-alt',
      'shopping-cart',
      'calendar',
      'headphones',
      'industry-alt',
      'plug',
      'puzzle-piece',
      'wrench',
      'bed',
      'microchip',
      'gem',
      'archive',
      'compass',
      'file',
      'search',
      'lock-alt',
      'paper-plane',
      'leaf',
      'briefcase',
      'utensil-spoon',
      'utensils',
      'bullseye',
      'flag',
      'fire-extinguisher',
      'tachometer',
      'copy',
      'train',
      'cube',
      'flask',
      'mobile-alt',
      'balance-scale',
      'watch',
      'heart',
      'home',
      'laptop',
      'utensils-alt',
      'tag',
      'shield-alt',
      'ambulance',
      'tv-retro',
      'book',
      'eye-dropper',
      'utensil-knife',
      'thumbtack',
      'eraser',
      'calendar-alt',
      'rocket',
      'fighter-jet',
      'plane',
      'globe',
      'gamepad',
      'subway',
      'road',
      'trophy',
      'coffee',
      'lemon',
      'money-bill',
      'images',
      'truck',
      'hdd',
      'film-alt',
      'motorcycle',
      'cubes',
      'glass-martini',
      'pencil',
      'print',
      'paste',
      'hospital',
      'graduation-cap',
      'plane-alt',
      'envelope',
      'save',
      'camera-alt',
      'lock-open-alt',
      'birthday-cake',
      'bath',
      'anchor',
      'industry',
      'paw',
      'binoculars',
      'bell',
      'car',
      'map-marker-alt',
      'sticky-note',
      'microphone',
      'suitcase',
      'shopping-bag',
      'newspaper',
      'mobile',
      'lock',
      'alarm-clock',
      'microphone-alt',
      'camera-retro',
      'shopping-basket',
      'tablet',
      'calculator',
      'paint-brush',
      'tree',
      'wheelchair',
      'tv',
      'map',
      'tags',
      'pencil-alt',
      'map-signs',
      'moon',
      'bicycle',
    ],
  },
  {
    type: 'category',
    label: 'Maps',
    icons: [
      'money-bill-alt',
      'ticket-alt',
      'bookmark',
      'bell-slash',
      'trophy-alt',
      'info-circle',
      'tree-alt',
      'eye-slash',
      'university',
      'search-minus',
      'building',
      'h-square',
      'shower',
      'map-marker',
      'phone',
      'lightbulb',
      'taxi',
      'image',
      'search-plus',
      'male',
      'key',
      'life-ring',
      'gavel',
      'magnet',
      'utensil-fork',
      'medkit',
      'info-square',
      'eye',
      'beer',
      'usd-square',
      'ticket',
      'umbrella',
      'gift',
      'map-pin',
      'flag-checkered',
      'crosshairs',
      'bomb',
      'tint',
      'fire',
      'shopping-cart',
      'industry-alt',
      'plug',
      'wrench',
      'heartbeat',
      'bed',
      'search',
      'leaf',
      'briefcase',
      'location-arrow',
      'utensil-spoon',
      'utensils',
      'flag',
      'fire-extinguisher',
      'train',
      'ship',
      'flask',
      'music',
      'balance-scale',
      'heart',
      'home',
      'usd-circle',
      'utensils-alt',
      'tag',
      'ambulance',
      'book',
      'utensil-knife',
      'thumbtack',
      'rocket',
      'fighter-jet',
      'plane',
      'globe',
      'gamepad',
      'subway',
      'road',
      'trophy',
      'wifi',
      'coffee',
      'lemon',
      'money-bill',
      'images',
      'truck',
      'plus-square',
      'motorcycle',
      'dollar-sign',
      'glass-martini',
      'low-vision',
      'print',
      'hospital',
      'graduation-cap',
      'plane-alt',
      'birthday-cake',
      'bath',
      'anchor',
      'industry',
      'paw',
      'binoculars',
      'bell',
      'car',
      'map-marker-alt',
      'suitcase',
      'recycle',
      'shopping-bag',
      'info',
      'blind',
      'newspaper',
      'shopping-basket',
      'plus',
      'street-view',
      'tree',
      'tty',
      'wheelchair',
      'phone-square',
      'map',
      'tags',
      'phone-volume',
      'map-signs',
      'bicycle',
    ],
  },
  {
    type: 'category',
    label: 'Interfaces',
    icons: [
      'barcode',
      'question',
      'circle',
      'share-alt',
      'pen',
      'i-cursor',
      'badge',
      'external-link',
      'sort-numeric-down',
      'database',
      'external-link-alt',
      'share-all',
      'bell-slash',
      'share',
      'cloud-download',
      'trophy-alt',
      'info-circle',
      'eye-slash',
      'share-square',
      'exclamation-circle',
      'search-minus',
      'dot-circle',
      'cut',
      'minus',
      'times-square',
      'magic',
      'sign-in-alt',
      'redo',
      'sort-down',
      'calendar-times',
      'sign-out',
      'minus-circle',
      'clone',
      'file-alt',
      'search-plus',
      'cloud',
      'toggle-off',
      'envelope-open',
      'upload',
      'bars',
      'sort-alpha-down',
      'calendar-edit',
      'info-square',
      'ellipsis-v',
      'certificate',
      'share-alt-square',
      'ban',
      'minus-octagon',
      'poo',
      'clipboard',
      'bug',
      'cogs',
      'folder-open',
      'cog',
      'eye',
      'beer',
      'trash',
      'times-hexagon',
      'pen-alt',
      'sliders-v',
      'external-link-square-alt',
      'undo',
      'quote-left',
      'bullhorn',
      'times-circle',
      'flag-checkered',
      'check',
      'sort-amount-up',
      'shield',
      'star',
      'trash-alt',
      'edit',
      'check-square',
      'user',
      'calendar',
      'sitemap',
      'minus-hexagon',
      'ellipsis-h',
      'sort-up',
      'sliders-v-square',
      'file',
      'search',
      'exclamation',
      'sliders-h-square',
      'calendar-plus',
      'bullseye',
      'flag',
      'rss-square',
      'quote-right',
      'copy',
      'cloud-upload',
      'sign-in',
      'times-octagon',
      'sync',
      'heart',
      'calendar-minus',
      'user-circle',
      'plus-hexagon',
      'home',
      'smile',
      'hashtag',
      'sort',
      'toggle-on',
      'reply',
      'shield-alt',
      'filter',
      'ellipsis-h-alt',
      'external-link-square',
      'eraser',
      'calendar-alt',
      'badge-check',
      'trophy',
      'wifi',
      'coffee',
      'folder',
      'cloud-download-alt',
      'plus-square',
      'download',
      'reply-all',
      'thumbs-up',
      'minus-square',
      'sort-amount-down',
      'plus-circle',
      'language',
      'question-square',
      'pencil',
      'paste',
      'calendar-check',
      'meh',
      'envelope',
      'save',
      'ellipsis-v-alt',
      'check-circle',
      'calendar-exclamation',
      'plus-octagon',
      'bell',
      'microphone-slash',
      'microphone',
      'user-alt',
      'sort-numeric-up',
      'sync-alt',
      'exclamation-square',
      'info',
      'sign-out-alt',
      'signal',
      'sort-alpha-up',
      'times',
      'qrcode',
      'star-half',
      'microphone-alt',
      'redo-alt',
      'question-circle',
      'sliders-h',
      'thumbs-down',
      'plus',
      'calculator',
      'frown',
      'star-exclamation',
      'undo-alt',
      'cloud-upload-alt',
      'pencil-alt',
      'exclamation-triangle',
      'history',
      'rss',
    ],
  },
  {
    type: 'category',
    label: 'Images',
    icons: [
      'portrait',
      'eye-slash',
      'rectangle-landscape',
      'camera',
      'image',
      'clone',
      'adjust',
      'eye',
      'compress-wide',
      'sliders-v',
      'film',
      'tint',
      'id-badge',
      'sliders-v-square',
      'sliders-h-square',
      'file-image',
      'rectangle-wide',
      'eye-dropper',
      'images',
      'expand-wide',
      'film-alt',
      'rectangle-portrait',
      'camera-alt',
      'compress',
      'id-card',
      'expand',
      'bolt',
      'camera-retro',
      'sliders-h',
    ],
  },
  {
    type: 'category',
    label: 'Health',
    icons: [
      'h-square',
      'medkit',
      'user-md',
      'accessible-icon',
      'stethoscope',
      'heartbeat',
      'heart',
      'ambulance',
      'plus-square',
      'hospital',
      'wheelchair',
    ],
  },
  {
    type: 'category',
    label: 'Hands',
    icons: [
      'hand-point-right',
      'hand-point-down',
      'hand-peace',
      'hand-paper',
      'hand-point-left',
      'handshake',
      'hand-spock',
      'hand-pointer',
      'hand-point-up',
      'hand-lizard',
      'thumbs-up',
      'hand-scissors',
      'thumbs-down',
      'hand-rock',
    ],
  },
  {
    type: 'category',
    label: 'Genders',
    icons: [
      'mercury',
      'genderless',
      'mars-double',
      'neuter',
      'mars-stroke-v',
      'venus-double',
      'mars',
      'transgender-alt',
      'mars-stroke-h',
      'transgender',
      'venus-mars',
      'mars-stroke',
      'venus',
    ],
  },
  {
    type: 'category',
    label: 'Files',
    icons: [
      'file-pdf',
      'cut',
      'file-code',
      'clone',
      'file-alt',
      'file-edit',
      'file-plus',
      'folder-open',
      'file-check',
      'archive',
      'file',
      'file-image',
      'copy',
      'file-exclamation',
      'file-archive',
      'file-word',
      'file-audio',
      'file-powerpoint',
      'folder',
      'paste',
      'save',
      'file-video',
      'file-times',
      'sticky-note',
      'file-minus',
      'file-excel',
    ],
  },
  {
    type: 'category',
    label: 'Editors',
    icons: [
      'align-center',
      'superscript',
      'pen',
      'i-cursor',
      'list-ul',
      'share-all',
      'share',
      'subscript',
      'cut',
      'th-list',
      'redo',
      'paragraph',
      'clone',
      'file-alt',
      'h2',
      'italic',
      'clipboard',
      'trash',
      'pen-alt',
      'undo',
      'quote-left',
      'paperclip',
      'trash-alt',
      'edit',
      'list-alt',
      'font',
      'text-width',
      'file',
      'paper-plane',
      'table',
      'quote-right',
      'copy',
      'h1',
      'align-right',
      'sync',
      'indent',
      'outdent',
      'reply',
      'bold',
      'eraser',
      'heading',
      'list-ol',
      'th-large',
      'reply-all',
      'strikethrough',
      'tasks',
      'h3',
      'pencil',
      'print',
      'paste',
      'text-height',
      'align-justify',
      'sync-alt',
      'align-left',
      'underline',
      'redo-alt',
      'th',
      'link',
      'undo-alt',
      'unlink',
      'pencil-alt',
      'columns',
      'list',
    ],
  },
  {
    type: 'category',
    label: 'Design',
    icons: [
      'pen',
      'eye-slash',
      'cut',
      'clone',
      'object-ungroup',
      'adjust',
      'eye',
      'pen-alt',
      'crosshairs',
      'tint',
      'edit',
      'copy',
      'object-group',
      'crop',
      'eye-dropper',
      'eraser',
      'pencil',
      'paste',
      'save',
      'paint-brush',
      'pencil-alt',
    ],
  },
  {
    type: 'category',
    label: 'Date & Time',
    icons: [
      'bell-slash',
      'clock',
      'calendar-times',
      'stopwatch',
      'calendar-edit',
      'hourglass',
      'calendar',
      'calendar-plus',
      'watch',
      'calendar-minus',
      'calendar-alt',
      'calendar-check',
      'hourglass-start',
      'calendar-exclamation',
      'hourglass-end',
      'bell',
      'alarm-clock',
      'hourglass-half',
    ],
  },
  {
    type: 'category',
    label: 'Currency',
    icons: [
      'money-bill-alt',
      'ruble-sign',
      'yen-sign',
      'bitcoin',
      'shekel-sign',
      'usd-square',
      'won-sign',
      'gg-circle',
      'rupee-sign',
      'usd-circle',
      'lira-sign',
      'money-bill',
      'dollar-sign',
      'pound-sign',
      'euro-sign',
      'gg',
      'btc',
    ],
  },
  {
    type: 'category',
    label: 'Computers',
    icons: [
      'tablet-alt',
      'mobile-android',
      'tablet-android-alt',
      'keyboard',
      'upload',
      'mobile-android-alt',
      'desktop-alt',
      'tablet-android',
      'power-off',
      'headphones',
      'plug',
      'microchip',
      'desktop',
      'mobile-alt',
      'laptop',
      'tv-retro',
      'server',
      'hdd',
      'download',
      'print',
      'save',
      'mobile',
      'tablet',
      'tv',
    ],
  },
  {
    type: 'category',
    label: 'Communication',
    icons: [
      'phone-slash',
      'comment',
      'bell-slash',
      'phone',
      'mobile-android',
      'envelope-open',
      'fax',
      'mobile-android-alt',
      'address-book',
      'bullhorn',
      'inbox-out',
      'paper-plane',
      'rss-square',
      'comment-alt',
      'address-card',
      'mobile-alt',
      'comments',
      'bluetooth',
      'wifi',
      'american-sign-language-interpreting',
      'at',
      'assistive-listening-systems',
      'language',
      'inbox-in',
      'envelope',
      'bluetooth-b',
      'bell',
      'microphone-slash',
      'microphone',
      'envelope-square',
      'mobile',
      'microphone-alt',
      'tty',
      'phone-square',
      'phone-volume',
      'rss',
      'inbox',
    ],
  },
  {
    type: 'category',
    label: 'Code',
    icons: [
      'window-alt',
      'barcode',
      'window-close',
      'user-secret',
      'window-minimize',
      'code',
      'file-code',
      'file-alt',
      'keyboard',
      'terminal',
      'window',
      'bug',
      'folder-open',
      'shield',
      'sitemap',
      'code-commit',
      'code-branch',
      'microchip',
      'archive',
      'file',
      'fire-extinguisher',
      'window-maximize',
      'shield-alt',
      'window-restore',
      'filter',
      'coffee',
      'folder',
      'browser',
      'shield-check',
      'bath',
      'code-merge',
      'qrcode',
    ],
  },
  {
    type: 'category',
    label: 'Business',
    icons: [
      'phone-slash',
      'pen',
      'badge',
      'cut',
      'building',
      'phone',
      'file-alt',
      'envelope-open',
      'fax',
      'chart-area',
      'chart-pie',
      'certificate',
      'clipboard',
      'folder-open',
      'pen-alt',
      'address-book',
      'bullhorn',
      'paperclip',
      'edit',
      'calendar',
      'sitemap',
      'chart-bar',
      'industry-alt',
      'trademark',
      'archive',
      'compass',
      'file',
      'briefcase',
      'bullseye',
      'table',
      'copy',
      'chart-line',
      'address-card',
      'balance-scale',
      'copyright',
      'tag',
      'book',
      'thumbtack',
      'eraser',
      'calendar-alt',
      'globe',
      'badge-check',
      'pencil-alt',
      'coffee',
      'folder',
      'tasks',
      'pencil',
      'paste',
      'envelope',
      'save',
      'birthday-cake',
      'industry',
      'sticky-note',
      'suitcase',
      'envelope-square',
      'registered',
      'percent',
      'calculator',
      'phone-square',
      'tags',
      'pencil-alt',
      'phone-volume',
      'columns',
    ],
  },
  {
    type: 'category',
    label: 'Audio & Video',
    icons: [
      'circle',
      'forward',
      'rectangle-landscape',
      'repeat',
      'redo',
      'stop',
      'youtube',
      'fast-forward',
      'audio-description',
      'backward',
      'expand-arrows-alt',
      'compress-wide',
      'film',
      'undo',
      'pause',
      'compress-alt',
      'fast-backward',
      'headphones',
      'scrubber',
      'closed-captioning',
      'volume-down',
      'rss-square',
      'step-backward',
      'expand-alt',
      'music',
      'sync',
      'rectangle-wide',
      'stop-circle',
      'file-audio',
      'repeat-1',
      'volume-up',
      'expand-wide',
      'film-alt',
      'repeat-1-alt',
      'volume-off',
      'rectangle-portrait',
      'eject',
      'file-video',
      'video',
      'compress',
      'podcast',
      'repeat-alt',
      'expand',
      'pause-circle',
      'microphone-slash',
      'microphone',
      'sync-alt',
      'microphone-alt',
      'redo-alt',
      'play-circle',
      'expand-arrows',
      'undo-alt',
      'volume-mute',
      'step-forward',
      'phone-volume',
      'random',
      'rss',
      'play',
    ],
  },
  {
    type: 'category',
    label: 'Arrows',
    icons: [
      'arrow-alt-square-up',
      'hand-point-right',
      'arrow-alt-to-right',
      'caret-circle-down',
      'arrow-alt-circle-up',
      'external-link',
      'sort-numeric-down',
      'external-link-alt',
      'share-all',
      'caret-right',
      'mouse-pointer',
      'level-up',
      'share',
      'cloud-download',
      'arrows-alt',
      'arrow-circle-left',
      'chevron-circle-down',
      'share-square',
      'arrow-to-left',
      'arrows-v',
      'caret-left',
      'repeat',
      'arrow-alt-up',
      'sign-in-alt',
      'arrow-right',
      'redo',
      'caret-square-left',
      'sort-down',
      'chevron-up',
      'sign-out',
      'hand-point-down',
      'chevron-square-right',
      'long-arrow-alt-right',
      'arrows-alt-v',
      'upload',
      'sort-alpha-down',
      'level-down-alt',
      'arrow-alt-from-top',
      'exchange-alt',
      'expand-arrows-alt',
      'caret-down',
      'cart-arrow-down',
      'chevron-circle-up',
      'angle-double-right',
      'arrow-alt-circle-down',
      'external-link-square-alt',
      'arrow-alt-circle-left',
      'undo',
      'caret-circle-left',
      'arrow-circle-right',
      'caret-circle-up',
      'sort-amount-up',
      'inbox-out',
      'angle-double-up',
      'level-up-alt',
      'chevron-double-right',
      'compress-alt',
      'angle-left',
      'long-arrow-right',
      'chevron-right',
      'triangle',
      'arrow-alt-down',
      'arrow-alt-from-bottom',
      'sort-up',
      'arrows-h',
      'arrow-alt-square-down',
      'hand-point-left',
      'caret-up',
      'angle-right',
      'arrow-alt-right',
      'chevron-down',
      'text-width',
      'arrow-alt-to-left',
      'angle-down',
      'arrow-to-top',
      'chevron-double-up',
      'location-arrow',
      'long-arrow-up',
      'long-arrow-alt-down',
      'arrow-alt-to-top',
      'arrow-alt-to-bottom',
      'chart-line',
      'cloud-upload',
      'expand-alt',
      'sign-in',
      'sync',
      'arrow-alt-left',
      'chevron-circle-right',
      'arrows',
      'chevron-circle-left',
      'arrow-left',
      'long-arrow-alt-left',
      'caret-square-down',
      'sort',
      'angle-double-left',
      'caret-square-right',
      'reply',
      'arrow-square-left',
      'exchange',
      'arrow-from-bottom',
      'arrow-alt-square-right',
      'arrow-down',
      'arrow-up',
      'arrow-alt-circle-right',
      'hand-pointer',
      'long-arrow-left',
      'chevron-square-up',
      'external-link-square',
      'hand-point-up',
      'long-arrow-alt-up',
      'arrow-from-right',
      'long-arrow-down',
      'retweet',
      'arrow-alt-square-left',
      'repeat-1',
      'chevron-square-down',
      'arrow-from-left',
      'cloud-download-alt',
      'repeat-1-alt',
      'download',
      'reply-all',
      'arrow-to-bottom',
      'chevron-double-down',
      'sort-amount-down',
      'chevron-square-left',
      'inbox-in',
      'text-height',
      'arrow-square-right',
      'chevron-double-left',
      'repeat-alt',
      'angle-double-down',
      'caret-square-up',
      'angle-up',
      'sort-numeric-up',
      'sync-alt',
      'recycle',
      'sign-out-alt',
      'sort-alpha-up',
      'arrows-alt-h',
      'arrow-square-up',
      'redo-alt',
      'arrow-alt-from-right',
      'arrow-from-top',
      'level-down',
      'chevron-left',
      'retweet-alt',
      'expand-arrows',
      'caret-circle-right',
      'undo-alt',
      'cloud-upload-alt',
      'random',
      'arrow-to-right',
      'history',
      'arrow-alt-from-left',
      'arrow-square-down',
      'play',
      'arrow-circle-down',
      'arrow-circle-up',
    ],
  },
  {
    type: 'category',
    label: 'Accessibility',
    icons: [
      'audio-description',
      'accessible-icon',
      'deaf',
      'closed-captioning',
      'braille',
      'american-sign-language-interpreting',
      'low-vision',
      'assistive-listening-systems',
      'sign-language',
      'blind',
      'universal-access',
      'question-circle',
      'tty',
      'wheelchair',
      'phone-volume',
    ],
  },
];

class CmsIconSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
    };
  }

  changeSearch = e => {
    this.setState({ searchText: e.target.value, page: 1 });
  };

  selectIcon = icon => {
    this.props.onSelect(icon);
  };

  getDefaultIcons = () => {
    return [
      'fa fa-check',
      'fa fa-clock',
      'fa fa-calendar-alt',
      'fa fa-times',
      'fa fa-exclamation',
      'fa fa-exclamation-circle',
      'fa fa-car',
      'fa fa-truck',
    ];
  };

  searchIcons = () => {
    let res = [];

    for (let i = 0; i < fa5icons.length; i++) {
      for (let j = 0; j < fa5icons[i].icons.length; j++) {
        if (fa5icons[i].icons[j].indexOf(this.state.searchText) > -1) {
          res.push('fa fa-' + fa5icons[i].icons[j]);
        }
      }

      if (res.length === 20) {
        return res;
      }
    }

    return res;
  };

  render() {
    let showIcons = this.getDefaultIcons();
    if (this.state.searchText) {
      showIcons = this.searchIcons();
    }

    return (
      <div style={{ width: '250px' }}>
        <input type="text" class="form-control" value={this.state.searchText} onChange={this.changeSearch} />
        <div class="p-t-10">
          {showIcons.map((icon, i) => {
            return (
              <Button key={i} class="m-r-5 m-b-5" title={icon} onClick={() => this.selectIcon(icon)}>
                <i class={'fa-fw ' + icon} />
              </Button>
            );
          })}
        </div>
      </div>
    );
  }
}

export default injectIntl(CmsIconSearch);
